// extracted by mini-css-extract-plugin
export default {"square-icon-sm":"SquareIcon_square-icon-sm__i6rg0","square-icon-md":"SquareIcon_square-icon-md__ctQOx","square-icon-lg":"SquareIcon_square-icon-lg__hauaG"};